import React from 'react'
import { withIcon } from '../../withIcon'

function ClockSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M12 5C8.14005 5 5 8.14005 5 12C5 15.86 8.14005 19 12 19C15.86 19 19 15.86 19 12C19 8.14005 15.86 5 12 5ZM15.3291 15.6207C15.2153 15.7345 15.066 15.7917 14.9167 15.7917C14.7674 15.7917 14.618 15.7345 14.5043 15.6207L11.5876 12.7041C11.4779 12.595 11.4167 12.4468 11.4167 12.2917V8.5C11.4167 8.17743 11.678 7.9167 12 7.9167C12.322 7.9167 12.5833 8.17743 12.5833 8.5V12.0502L15.3291 14.7959C15.5571 15.024 15.5571 15.3927 15.3291 15.6207Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ClockSolidIcon)
